<template>
    <div>
        <div class="transfer-boxes">
            <div class="left-box common-box">
                <p class="left-header common-header">
                    <el-checkbox 
                        :indeterminate="isIndeterminateSource" 
                        :disabled="filteredSourceData.length==0" 
                        v-model="checkAllSource" 
                        @change="sourceAllCheckChange">
                        <slot :row="sourceTitle" name="sourceTitle">{{sourceTitle}}</slot>
                        </el-checkbox>
                        <span class="total-count">{{sourceCheckedData.length}}/{{filteredSourceData.length}}</span>
                </p>
                <div class="left-body common-body" v-loading="leftLoading">
                    <div class="search-box" v-if="isSearch">
                        <el-input size="mini" v-model="searchLeftInput" :placeholder="searchPlaceholder" @input="onSearch($event,true)" key="searchLeft">
                            <template slot="prepend"><i class="fas fa-search"></i></template>
                        </el-input>
                    </div>
                    <div class="load-content">
                        <el-checkbox-group v-model="sourceCheckedData" @change="sourceEachCheckedChange">
                            <el-checkbox 
                                v-for="(item , i) in getPagedData(filteredSourceData, currentLeftPage)" 
                                :key="i" :label="item" class="check-item" 
                                :disabled="item.disabled">
                                    <slot :row="item" name="leftLabel">{{ item.label }}</slot>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="common-footer left-foot">
                        <span slot="left-footer">
                            <el-pagination
                                    small
                                    :current-page="currentLeftPage"
                                    :page-size="perPage"
                                    :total="filteredSourceData.length"
                                    layout="prev,pager,next"
                                    :hide-on-single-page="true"
                                    @current-change="pageChange($event,true)"
                                    @size-change="resizePagination($event)"
                            ></el-pagination>
                        </span>
                    </div>
                </div>
            </div>
            <div class="transfer-button-box">
                <el-button type="primary" :disabled="targetCheckedData.length==0 || filteredTargetData.length==0" @click="targetToSource">
                    <i class="el-icon-arrow-left"></i> {{outBtnText}}
                </el-button>
                <el-button type="primary" :disabled="sourceCheckedData.length==0 || filteredSourceData.length==0" @click="sourceToTarget">
                    {{inBtnText}} <i class="el-icon-arrow-right"></i>
                </el-button>
            </div>
            <div class="right-box common-box">
                <p class="right-header common-header">
                    <el-checkbox 
                        :indeterminate="isIndeterminateTarget" 
                        :disabled="filteredTargetData.length==0" 
                        v-model="checkAllTarget" 
                        @change="targetAllCheckChange">
                            <slot :row="targetTitle" name="targetTitle">{{targetTitle}}</slot>
                    </el-checkbox>
                    <span class="total-count">{{targetCheckedData.length}}/{{filteredTargetData.length}}</span>
                </p>
                <div class="right-body common-body"  v-loading="rightLoading">
                    <div class="search-box" v-if="isSearch">
                        <el-input size="mini" v-model="searchRightInput" :placeholder="searchPlaceholder" @input="onSearch($event,false)" key="searchRight">
                            <template slot="prepend"><i class="fas fa-search"></i></template>
                        </el-input>
                    </div>
                    <div class="right-content">
                        <el-checkbox-group v-model="targetCheckedData" @change="targetEachCheckedChange">
                            <el-checkbox 
                                v-for="(item ,i) in getPagedData(filteredTargetData, currentRightPage)" :key="i" 
                                :label="item" class="check-item">
                                    <slot :row="item" name="rightLabel"></slot>{{ item.label }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="common-footer right-foot"><slot name="right-footer"></slot></div>
                </div>
                <div class="common-footer right-foot">
                        <span slot="right-footer">
                            <el-pagination
                                    small
                                    :current-page="currentRightPage"
                                    :page-size="perPage"
                                    :total="filteredTargetData.length"
                                    layout="prev,pager,next"
                                    :hide-on-single-page="true"
                                    @current-change="pageChange($event,false)"
                                    @size-change="resizePagination($event)"
                            ></el-pagination>
                        </span>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'Transfer',
    props: {
        sourceTitle: {
            type: String,
            default: "All Sources"
        },
        targetTitle: {
            type: String,
            default: "All Targets"
        },
        isSearch: {
            type: Boolean,
            default: true
        },
        outBtnText:{
            type:String,
            default:""
        },
        inBtnText:{
            type:String,
            default:""
        },
        searchPlaceholder:{
            type:String,
            default:"Search"
        },
        options:{
            type:Array,
            default: []
        },
        selected:{
            type:Array,
            default: []
        },
        minSearchLength:{
            type:Number,
            default:3
        }
    },
    data() {
        return {
            sourceData: [],
            targetData: [],
            checkAllSource: false,
            checkAllTarget: false,
            sourceCheckedData: [],
            targetCheckedData: [],
            isIndeterminateSource: false,
            isIndeterminateTarget: false,
            currentLeftPage: 1,
            currentRightPage: 1,
            perPage: 8,
            searchLeftInput: "",
            searchRightInput: "",
            filteredSourceData: [],
            filteredTargetData: [],
            leftLoading: true,
            rightLoading: true
        }
    },
    methods: {
        getPagedData(data,currentPage){
            return data.slice(
                (currentPage - 1) * this.perPage,
                currentPage * this.perPage,
            );
        },
        sourceAllCheckChange(val){
            this.sourceCheckedData = val ? this.filteredSourceData : [];
        },
        targetAllCheckChange(val){
            this.targetCheckedData = val ? this.filteredTargetData: [];
        },
        sourceEachCheckedChange(){
            this.checkAllSource = _.size(this.sourceData) == _.size(this.sourceCheckedData);
            this.isIndeterminateSource = !this.checkAllSource && !_.isEmpty(this.sourceCheckedData);
        },
        targetEachCheckedChange(){
            this.checkAllTarget = _.size(this.targetData) == _.size(this.targetCheckedData);
            this.isIndeterminateTarget = !this.checkAllTarget && !_.isEmpty(this.targetCheckedData);
        },
        onSearch(val,isLeft=true){
            if(val.length >= this.minSearchLength){
                if(isLeft){
                    this.filteredSourceData = _.filter(this.sourceData, o=> _.includes(_.lowerCase(o.label), _.lowerCase(val)));
                }
                else{
                    this.filteredTargetData = _.filter(this.targetData, o=> _.includes(_.lowerCase(o.label), _.lowerCase(val)));
                }
            }else{
                if(isLeft){
                    this.filteredSourceData = this.sourceData;
                }
                else{
                    this.filteredTargetData = this.targetData;
                }
            }
        },
        targetToSource(){
            let removalIds = _.map(this.targetCheckedData, 'id');
            this.targetData = _.filter(this.targetData, o=> !_.includes(removalIds, o.id))
            this.targetCheckedData = [];
            this.checkAllTarget = false;
            this.isIndeterminateTarget = false;
        },
        sourceToTarget(){
            this.targetData = _.concat(this.targetData, this.sourceCheckedData);
            this.sourceCheckedData = [];
            this.checkAllSource = false;
            this.isIndeterminateSource = false;
        },
        onChange() {
            let targetIds = _.map(this.targetData, 'id');
            this.sourceData = _.filter(_.cloneDeep(this.options), o=> !_.includes(targetIds, o.id));
            this.filteredSourceData = _.filter(this.sourceData, o=> _.includes(_.lowerCase(o.label), _.lowerCase(this.searchLeftInput)));
            this.filteredTargetData = _.filter(this.targetData, o=> _.includes(_.lowerCase(o.label), _.lowerCase(this.searchRightInput)));
            this.$emit("onChange",targetIds);
        },
        pageChange(val,isLeft=true){
            if(isLeft){
                this.currentLeftPage = val;
            }
            else{
                this.currentRightPage = val;
            }
        },
        resizePagination(val){
            this.pageSize = val;
            this.currentLeftPage = 1;
            this.currentRightPage = 1;
        },
        init(){
            this.sourceData = _.filter(_.cloneDeep(this.options), o=> !_.includes(this.selected, o.id));
            this.targetData = _.filter(_.cloneDeep(this.options), o=> _.includes(this.selected, o.id));
            this.filteredSourceData = _.filter(this.sourceData, o=> _.includes(_.lowerCase(o.label), _.lowerCase(this.searchLeftInput)));
            this.filteredTargetData = _.filter(this.targetData, o=> _.includes(_.lowerCase(o.label), _.lowerCase(this.searchRightInput)));
            return Promise.resolve(true);
        }
    },
    watch:{
        targetData:function(){
            this.onChange();
        },
        selected:function(val){
            if(_.size(this.targetData) != _.size(val)){
                this.init();
            }
        }
    },
    created() {
        this.init()
            .then(()=>{
                this.leftLoading = false;
                this.rightLoading = false;
            });
    }
};
</script>

<style lang="scss" scoped>
    .transfer-boxes{
        display: inline-block;
        text-align: left;
        width: 100%;
    }
    .transfer-boxes .common-box{
        border: 1px solid #EBEEF5;
        border-radius: 4px;
        overflow: hidden;
        background: #FFF;
        display: inline-block;
        vertical-align: middle;
        width: 40%;
        max-height: 100%;
        box-sizing: border-box;
        position: relative;
    }
    .transfer-boxes .common-header{
        height: 40px;
        line-height: 40px;
        background: #F5F7FA;
        margin: 0;
        padding-left: 15px;
        border-bottom: 1px solid #EBEEF5;
        box-sizing: border-box;
        color: #000;
    }
    .transfer-boxes .total-count{
        position: absolute;
        right: 15px;
        color: #909399;
        font-size: 12px;
        font-weight: 400;
    }
    .transfer-boxes .common-body{
        padding-top:0.5rem;
        height:400px;
    }
    .transfer-boxes .right-content{
        height:344px;
        margin: 0;
        padding: 6px 0;
        list-style: none;
        overflow: auto;
        box-sizing: border-box;
        text-align: left;
    }
    .transfer-boxes .common-footer{
        height: 40px;
        background: #FFF;
        margin: 0;
        padding: 6px;
        border-top: 1px solid #EBEEF5;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1;
        text-align: center;
    }
    .transfer-boxes .common-body .search-box{
        justify-content:center;
        padding:0 1rem 0.5rem 1rem;
    }
    .transfer-boxes .common-body .search-box /deep/ .el-input{
        border: 1px solid rgba(208,208,208,.6);
        border-radius: 100px;
    }
    .transfer-boxes .common-body .search-box /deep/ .el-input__inner{
        padding: 0 15px 0 1px;
        background-color: rgba(0,0,0,0);
        border: none;
    }
    .transfer-boxes .common-body .search-box /deep/ .el-input-group__prepend {
        color: rgba(208,208,208,.8);
        padding: 0 1px 0 10px;
        background-color: rgba(0,0,0,0);
        border: none;
    }
    .common-body .load-content{
        height:316px;
        margin: 0;
        padding: 6px 0;
        list-style: none;
        overflow: auto;
        box-sizing: border-box;
        text-align: left;
    }
    .transfer-boxes .check-item{
        height: 30px;
        line-height: 30px;
        padding-left: 15px;
        display: block!important;
    }
    .transfer-boxes .transfer-button-box{
        display: inline-block;
        vertical-align: middle;
        width: 16%;
        padding: 0 2%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Transfer.vue